import React from 'react';

import './Logo.scss';

const Logo = () => {
  return (
    <div className="logo">
      <h1 className="logo__text">
        Travel<span>Ready</span>
      </h1>
    </div>
  );
};

export { Logo };
